import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

export function useAudit(filters = {}) {
  return useQuery({
    queryKey: ['settings', 'audit', filters],
    queryFn: async () => {
      const { data } = await api.get('/audit', { params: filters });
      return data;
    },
    keepPreviousData: true,
    staleTime: 15_000
  });
}

export function useAuditEntry(id) {
  return useQuery({
    queryKey: ['settings', 'audit-entry', id],
    queryFn: async () => {
      const { data } = await api.get(`/audit/${id}`);
      return data?.entry || data?.data || data;
    },
    enabled: !!id,
    staleTime: 60_000
  });
}
